import React, { useRef, useState } from "react";
import { ImagePlus, X, Loader2 } from "lucide-react";
import { api, imgUrl, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Widget de upload de imagens usado no painel admin
export default function ImagePicker({ images = [], onChange, multiple = true, label = "Imagens" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const list = Array.isArray(images) ? images : images ? [images] : [];

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const next = multiple ? [...list, data.url] : [data.url];
      onChange(multiple ? next : data.url);
      toast.success("Imagem enviada!");
    } catch (err) {
      toast.error(formatApiError(err, "Falha no upload"));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (idx) => {
    const next = list.filter((_, i) => i !== idx);
    onChange(multiple ? next : "");
  };

  return (
    <div data-testid="image-picker">
      <p className="text-xs font-bold text-slate-600 mb-2">{label}</p>
      <div className="flex flex-wrap gap-3">
        {list.map((img, i) => (
          <div key={i} className="relative w-20 h-20 rounded-xl overflow-hidden border border-slate-200 group">
            <img src={imgUrl(img)} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              aria-label="Remover imagem"
              data-testid={`image-remove-${i}`}
              className="absolute top-1 right-1 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <X size={11} />
            </button>
          </div>
        ))}
        {(multiple || list.length === 0) && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid="image-upload-btn"
            className="w-20 h-20 rounded-xl border-2 border-dashed border-slate-300 hover:border-pink-400 flex flex-col items-center justify-center gap-1 text-slate-400 hover:text-pink-500 transition-colors"
          >
            {uploading ? <Loader2 size={18} className="animate-spin" /> : <ImagePlus size={18} />}
            <span className="text-[10px] font-bold">{uploading ? "Enviando" : "Upload"}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={upload} data-testid="image-file-input" />
    </div>
  );
}
